export const drawerItemsMain = [
  {
    key: "ChinaTracker",
    title: "China Tracker",
    routes: [
      {
        nav: "ChinaTrackerReport",
        routeName: "ChinaTrackerReport",
        title: "China Tracker Report",
      },
    ],
  },
];
